import {
  OPEN_SIGN_IN,
  OPEN_SIGN_UP,
  OPEN_FORGOT_PASSWORD,
  OPEN_SELECT_ROLE,
  CLOSE_ALL,
  OPEN_HAS_CONFIRM_ROTATION,
  OPEN_WHITELIST,
} from 'actions/authDialogConstants';

export const openSignIn = () => ({ type: OPEN_SIGN_IN });
export const openSignUp = () => ({ type: OPEN_SIGN_UP });
export const openWhitelist = () => ({ type: OPEN_WHITELIST });
export const openForgotPassword = () => ({ type: OPEN_FORGOT_PASSWORD });
export const openSelectRole = () => ({ type: OPEN_SELECT_ROLE });
export const closeAll = () => ({ type: CLOSE_ALL });
export const openHasConfirmRotation = () => ({ type: OPEN_HAS_CONFIRM_ROTATION });
